import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Confriend = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='confriend'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-confriend.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                <p>
                    Marona can use a special version of Confine called <span className='text-pborange'>Confriend</span>{' '}
                    to allow an allied Phantom to possess her. By Confriending allies she has a{' '}
                    <span className='text-pborange'>close bond with, her stats will greatly increase</span>!
                </p>
                <p className='mt-4'>
                    In addition, <span className='text-pborange'>special skills unique to Confriend</span> will also
                    become available. Unleash powerful attacks to completely turn the tide of battle!
                </p>{' '}
                <div className='flex mt-8'>
                    <div className='flex flex-col md:flex-row gap-4 mt-8'>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confriend', 1)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-1-s.webp`}
                            />
                        </div>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confriend', 2)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-2-s.webp`}
                            />{' '}
                        </div>{' '}
                    </div>{' '}
                </div>{' '}
                <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                    Marona's appearance will also change, depending on the ally she Confriends with!
                </p>
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='One more'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-onemore.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-3/5 mx-auto mt-12'>
                <p>
                    If certain conditions are met when Marona uses Confriend to Confine Phantoms within herself, it will
                    activate the <span className='text-pborange'>multi-turn Again</span>!
                </p>
                <p className='mt-4'>
                    This allows Marona to take additional turns and gain stat boosts. The deeper the bond between Marona
                    and the character she has Confriended with is, the more Agains she will activate, resulting in even
                    bigger stat boosts! It's even possible to completely wipe out the enemy in one go by chaining
                    multiple Agains!
                </p>
                <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'confriend', 3)
                            }}
                            className='ss-thumb'
                            alt='screen shot of game system'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-3-s.webp`}
                        />
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Feel the thrill of defeating enemies in succession, all by yourself!
                        </p>
                    </div>
                </div>{' '}
            </div>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={3}
            />
        </>
    )
}
